import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        allowRedirectInIframe: true
    }
};

const msalInstance = new PublicClientApplication(msalConfig);

// Scope constants for delegated API calls.
// All values must be supplied via environment variables at build time.
// A missing scope will produce an empty string which MSAL will reject early — fail fast by design.
export const SCOPES = {
    // AD Graph — delegated permission to read signed-in user profile
    USER_READ: "User.Read",

    // OP Activation endpoint
    OUTAGE_API: process.env.REACT_APP_DEV_OUTAGE_SCOPE,

    // Backend APIs (Snapshot, StateChange)
    SNAPSHOT: process.env.REACT_APP_SNAPSHOT_SCOPE,
    STATE_CHANGE: process.env.REACT_APP_STATE_CHANGE_SCOPE,

    // Translation API (request form + reports).
    // This scope is used only for backend API bearer tokens, not UI access gating.
    // Do not fallback to REACT_APP_SCOPE (often Graph) to avoid sending wrong-audience tokens.
    TRANSLATION: process.env.REACT_APP_TRANSLATION_SCOPE,

    // Contentful API for reports and management
    CONTENTFUL: process.env.REACT_APP_CONTENTFUL_SCOPE
};

export default msalInstance;

 
